import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/Auth/ProtectedRoute.jsx';
import Layout from './components/Layout/Layout.jsx';
import UpdateDialog from './components/UpdateDialog.jsx';
import Analysis from './pages/Analysis.jsx';
import { DeviceView } from './pages/DeviceView.jsx';
import ProjectExplorer from './pages/ProjectExplorer.jsx';
import { checkForAppUpdate } from './services/backend/updater.js';
import { useAuthStore } from './stores/authStore.js';
import theme from './theme/theme.js';
import './App.css';
import './styles/dockview-theme.css';

const EmptyPage = ({ title }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
      color: '#394b57',
    }}
  >
    {title} — coming soon
  </div>
);

const App = () => {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    initializeAuth();
    checkForAppUpdate();
  }, [initializeAuth]);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <UpdateDialog />
        <ProtectedRoute>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/projects" replace />} />
              <Route path="projects" element={<ProjectExplorer />} />
              <Route path="analysis" element={<Analysis />} />
              <Route path="measurements" element={<Navigate to="/analysis" replace />} />
              <Route path="reports" element={<EmptyPage title="Reports" />} />
              <Route path="desktop-view" element={<DeviceView />} />
              <Route path="*" element={<Navigate to="/projects" replace />} />
            </Route>
          </Routes>
        </ProtectedRoute>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
